import React from "react";
import { User } from "../types";
import PlayerItemMedium from "./items/player/medium";
import DefaultPlayerMeta from "./items/player/defaultMeta";
import { formatName } from "../libs/formatName";
import cx from "classnames";

type OnSelect = (user: User) => void;

const UsersList = ({ users, onSelect, selectedUser }: { users: User[]; onSelect: OnSelect; selectedUser?: User }) => {
	return (
		<div className="table players">
			{users.map((user, key) => {
				const className = cx("cell", { selected: selectedUser ? user.userId === selectedUser.userId : false });
				return (
					<div key={key} className={className} onClick={() => onSelect(user)}>
						<PlayerItemMedium
							name={user.fullName ? user.fullName : formatName(user.firstName, user.lastName)}
							meta={DefaultPlayerMeta(user)}
							photoUrl={user.photoUrl}
							isBuddy={user.userRelationship === "accepted"}
							coach={user.coachType}
							key={key}
						/>
					</div>
				);
			})}
		</div>
	);
};

export default UsersList;
